module.exports = __webpack_public_path__ + "img/Harari_Certificate.bd3f040e.jpg";